import axios from 'axios'

const getAPI_BaseURL = function () {
  return process.env.VUE_APP_AGRI_API_BASE_URL;
};

export const Axios = axios.create({
    baseURL: getAPI_BaseURL(), // '/api/',
    timeout: 30 * 1000,
    headers: {
        'Accept': 'application/json', // 讓後端知道式 API 呼叫，不自動導向，而是回傳 json
        'Content-Type': 'application/json; charset=utf-8', // 聲明 data 格式為 json
        'Cache-Control': 'max-age=86400', // Cache-Control: max-age=<seconds> // Cache-Control: must-revalidate
        'Strict-Transport-Security': 'max-age=86400; includeSubDomains; preload', // 讓瀏覽器強制跳轉 HTTPS 訪問
    }
})
/*
// POST 傳遞參數序列化( 添加 request 攔截器 )
// 在發送请求之前做某件事
Axios.interceptors.request.use(config => {

    // token
    if (localStorage.token) {
        config.headers.Authorization = 'bearer ' + localStorage.token
    }
    return config
}, error => {
    console.log( '錯誤的參數傳遞', 'fail' )
    return Promise.reject(error)
})

//返回狀態判断 ( 添加 response 攔截器)
Axios.interceptors.response.use( response => {
    // 如果回傳資料的 header 有帶 token，表示後端已經幫忙更新一支新的 token 了，有拿到就存下來
    let token = response.headers.authorization
    if (token) {
        // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
        //this.$store.commit('refreshToken', token)
    }
    return response
}, error => {
    let _baseURL = process.env.BASE_URL;

    if ( error.response.status === 401 )
    {
      // 401 表示 token 驗證失敗、過期
      // 非 login page 就直接跳轉到登入頁面，重新登入取得新 token
      let _page = _baseURL + 'login';

      if ( location.pathname !== _page ) {
        location.href = _page
      }
    }
    else if ( error.response.status === 500 )
    {
      location.href = _baseURL + '500';
      // 服务器錯誤
      return Promise.reject(error.response.data)
    }
    // 返回 response 里的錯誤資訊
    return Promise.reject(error.response.data)
})
*/
export default {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$http', {
            value: Axios
        })
    }
}
